import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

function PrivateOutlet() {
	const { accessToken: token, roleId } = useSelector((state) => state.auth);

	const location = useLocation();

	// if(incomingUserId && (userId !== incomingUserId)) {
	//   console.log('email');
	//   if() {
	//     return <Outlet />;
	//   } else {
	//     return <Navigate to={{pathname: '/login'}} state={{ from: location }} />;
	//   }
	// }
	// }else if(token && roleId) {
	//   console.log('outline');
	//   return <Outlet />;
	// } else {
	//   console.log('login');
	//   return <Navigate to={{pathname: '/login'}} state={{ from: location }} />;
	// }

	return token && roleId ? <Outlet /> : <Navigate to={{ pathname: '/login' }} state={{ from: location }} replace />;
}

export default PrivateOutlet;
